import { __assign, __awaiter, __generator } from 'tslib';
import React__default, { useContext, useCallback, useMemo } from 'react';
import { CartContext } from '../../../context/CartContext.esm.js';
import { CartSettingsContext } from '../../../context/CartSettingsContext.esm.js';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import { NvCheckbox } from '@invitae/ids-react';
import 'lodash/isEmpty';
import { useAnalyticsQueue } from '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import { AnalyticsEventName } from '../../../constants/analytics.esm.js';
import '../../../modals/content/index.esm.js';
import '../../../modals/content/default_validation_error.esm.js';
import '../../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../../constants/api.esm.js';
import ReflexTest from '../ReflexTest/ReflexTest.esm.js';
import Test from '../Test.esm.js';
import { ADD_RNA_ANALYSIS_TO_REFLEX, ADD_RNA_ANALYSIS } from '../../../constants/rna.esm.js';
import styles from './RnaAnalysisContainer.module.esm.js';

var RnaAnalysisContainer = function (_a) {
    var _b, _c;
    var isReflex = _a.isReflex, isRnaAnalysisSelected = _a.isRnaAnalysisSelected, rereqSetCode = _a.rereqSetCode, rnaAnalysisTestSelection = _a.rnaAnalysisTestSelection;
    var _d = useContext(CartContext), addToCart = _d.addToCart, addReflexTests = _d.addReflexTests, cart = _d.cart, removeFromCart = _d.removeFromCart, removeReflexTests = _d.removeReflexTests;
    var _e = React__default.useContext(CartSettingsContext), isCompact = _e.isCompact, isEditable = _e.isEditable;
    var _f = (((_c = (_b = cart === null || cart === void 0 ? void 0 : cart.orderGroups) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.meta) || {}).rna, rna = _f === void 0 ? {} : _f;
    var logEvent = useAnalyticsQueue().logEvent;
    var logRnaAnalysisEvent = useCallback(function (eventName) {
        logEvent({
            eventName: eventName,
            eventProperties: __assign({}, rna),
        });
    }, [logEvent, rna]);
    var rnaGeneCodes = useMemo(function () { var _a; return ((_a = rnaAnalysisTestSelection === null || rnaAnalysisTestSelection === void 0 ? void 0 : rnaAnalysisTestSelection.genes) === null || _a === void 0 ? void 0 : _a.map(function (gene) { return gene.code; })) || []; }, [rnaAnalysisTestSelection === null || rnaAnalysisTestSelection === void 0 ? void 0 : rnaAnalysisTestSelection.genes]);
    // Parent
    var handleRemoveParentRnaAnalysis = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // Since we know the RNA genes that have been added to the cart, we
                // can pass the codes to cart-service when they need to be removed
                return [4 /*yield*/, removeFromCart(rnaGeneCodes, undefined, undefined, { expandWithRna: false })];
                case 1:
                    // Since we know the RNA genes that have been added to the cart, we
                    // can pass the codes to cart-service when they need to be removed
                    _a.sent();
                    logRnaAnalysisEvent(AnalyticsEventName.DeselectParentRnaAnalysisCheckbox);
                    return [2 /*return*/];
            }
        });
    }); }, [logRnaAnalysisEvent, removeFromCart, rnaGeneCodes]);
    var toggleParentRnaAnalysis = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isRnaAnalysisSelected) return [3 /*break*/, 1];
                    handleRemoveParentRnaAnalysis();
                    return [3 /*break*/, 3];
                case 1: 
                // We don't necessarily have the DNA-to-RNA mapping when a user
                // adds a new test selection to the cart after RNA analysis has
                // been selected and so we pass expandWithRna to cart-service
                // for the RNA genes to be added to the cart programmatically
                return [4 /*yield*/, addToCart([], { expandWithRna: true })];
                case 2:
                    // We don't necessarily have the DNA-to-RNA mapping when a user
                    // adds a new test selection to the cart after RNA analysis has
                    // been selected and so we pass expandWithRna to cart-service
                    // for the RNA genes to be added to the cart programmatically
                    _a.sent();
                    logRnaAnalysisEvent(AnalyticsEventName.SelectParentRnaAnalysisCheckbox);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [addToCart, handleRemoveParentRnaAnalysis, isRnaAnalysisSelected, logRnaAnalysisEvent]);
    // Reflex
    var handleRemoveReflexRnaAnalysis = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, removeReflexTests(rereqSetCode, rnaGeneCodes, { expandWithRna: false })];
                case 1:
                    _a.sent();
                    logRnaAnalysisEvent(AnalyticsEventName.DeselectReflexRnaAnalysisCheckbox);
                    return [2 /*return*/];
            }
        });
    }); }, [logRnaAnalysisEvent, removeReflexTests, rereqSetCode, rnaGeneCodes]);
    var toggleReflexRnaAnalysis = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isRnaAnalysisSelected) return [3 /*break*/, 1];
                    handleRemoveReflexRnaAnalysis();
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, addReflexTests(rereqSetCode, [], { expandWithRna: true })];
                case 2:
                    _a.sent();
                    logRnaAnalysisEvent(AnalyticsEventName.SelectReflexRnaAnalysisCheckbox);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [addReflexTests, handleRemoveReflexRnaAnalysis, isRnaAnalysisSelected, logRnaAnalysisEvent, rereqSetCode]);
    return (React__default.createElement("div", { className: styles.root, "data-testid": "rna-analysis-container" },
        React__default.createElement("div", { className: styles.inner },
            isEditable && (React__default.createElement("div", { className: styles.wrapperCheckbox },
                React__default.createElement(NvCheckbox, { checked: isRnaAnalysisSelected || false, className: styles.checkbox, "data-testid": "rna-analysis-toggler", label: isReflex ? ADD_RNA_ANALYSIS_TO_REFLEX : ADD_RNA_ANALYSIS, onChange: isReflex ? toggleReflexRnaAnalysis : toggleParentRnaAnalysis }))),
            isRnaAnalysisSelected && rnaAnalysisTestSelection && (React__default.createElement(React__default.Fragment, null, isReflex ? (React__default.createElement("div", { className: styles.reflexTestsWrapper },
                React__default.createElement("div", { className: styles.reflexTest, "data-testid": "reflex-test-item" },
                    React__default.createElement(ReflexTest, { isRnaAnalysisTestSelection: true, removeReflexTest: handleRemoveReflexRnaAnalysis, test: rnaAnalysisTestSelection })))) : (React__default.createElement("div", { className: isCompact ? styles.mainInfoWrapperCompact : styles.mainInfoWrapper },
                React__default.createElement(Test, { handleDeleteTest: handleRemoveParentRnaAnalysis, hideGenes: false, test: rnaAnalysisTestSelection }))))))));
};

export { RnaAnalysisContainer as default };
//# sourceMappingURL=RnaAnalysisContainer.esm.js.map
